import { useSearchParams } from "react-router";

type Sorting = {
	id: string;
	desc: boolean;
};

export const DEFAULT_PAGE_LIMIT = 20;
export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_SORTING = [{ id: "dateCreated", desc: true }];

export const useTableFilter = (
	defaultPageLimit = DEFAULT_PAGE_LIMIT,
	defaultPageIndex = DEFAULT_PAGE_INDEX,
	defaultSorting: Sorting[] = DEFAULT_SORTING,
) => {
	const [searchParams, setSearchParams] = useSearchParams({
		pageIndex: String(defaultPageIndex),
		pageLimit: String(defaultPageLimit),
		sorting: JSON.stringify(defaultSorting),
	});

	const pageIndex = Number(searchParams.get("pageIndex"));
	const pageLimit = Number(searchParams.get("pageLimit"));

	let sorting: { id: string; desc: boolean }[] = [];

	try {
		const sortingParam = searchParams.get("sorting");
		if (sortingParam) {
			sorting = JSON.parse(sortingParam);
		}
	} catch (e) {
		console.error("Failed to parse sorting param", e);
	}

	const updateSearchParams = (params: {
		pageIndex?: number;
		pageLimit?: number;
		sorting?: { id: string; desc: boolean }[];
	}) => {
		const newParams = new URLSearchParams(searchParams);

		if (params.pageIndex !== undefined)
			newParams.set("pageIndex", String(params.pageIndex));

		if (params.pageLimit !== undefined)
			newParams.set("pageLimit", String(params.pageLimit));

		if (params.sorting !== undefined)
			newParams.set("sorting", JSON.stringify(params.sorting));

		setSearchParams(newParams);
	};

	return {
		pageIndex,
		pageLimit,
		sorting,
		searchParams,
		setSearchParams: updateSearchParams,
	};
};
